export default __webpack_public_path__ + "static/media/info02_Correo_validado.06a700af.png";